import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { ViewColumn } from "@mui/icons-material";
type Props = {
  handleToggleClick?: ()=>void,
  isActive: string
};

const UWCustomToggle: React.FC<Props> = ({ handleToggleClick,isActive }) => {
     return (
       <Tooltip title={isActive === "basic" ? "Toggle Columns" : "Untoggle Columns"}>
         <IconButton
           style={isActive === "basic" ? undefined : { color: "#016a01"}}
           onClick={handleToggleClick}
           size="large">
           <ViewColumn />
         </IconButton>
       </Tooltip>
     );
};

export default (UWCustomToggle);
